/**
 * WEB-1651-3 — цвет САМОЙ ОТМЕТКИ нативных чекбоксов и радио (CSS
 * `accent-color`), а не текста варианта и не его подложки (те живут в
 * optionSelectedColor.ts / стиль-паке).
 *
 * Репорт PM: «у блока опций ответов нельзя выбрать цвет заливки чекбоксов —
 * ни настройкой в панели (её нет), ни через ИИ-чат (не красит)». Инпуты
 * рисовались с единственным стилем `{width:18,height:18}`, `accent-color` не
 * задавался НИГДЕ — отметка оставалась системно-синей при любой палитре.
 *
 * ДВА СЛОЯ, ПОРЯДОК СИЛЫ (шрам WEB-934 про слой-победитель):
 *  1. `block.optionAccentColor` — явный выбор автора, сильнее всего;
 *  2. `var(--color-primary)` — палитра воронки. Это осознанное УЛУЧШЕНИЕ
 *     дефолта: даже у воронок без настройки отметки перестают быть системно
 *     синими и красятся акцентом воронки.
 * Отдельного CSS-правила `accent-color` в styles/ нет и заводить его нельзя —
 * иначе получится два источника правды на одно свойство.
 *
 * Список типов — ЗЕРКАЛО канона бэка (backend/src/ai-funnels/block-schema/
 * option-accent-color.ts, OPTION_ACCENT_BLOCK_TYPES): он же решает, каким
 * блокам панель показывает поле «Цвет отметки». Разъезд ловит сторож
 * option-accent-color.web1651.spec.ts (читает ЭТОТ файл с диска) — не
 * переименовывать и не менять форму `new Set([...])` не обновив его.
 *
 * `image_choice` намеренно НЕ здесь: его варианты — фото-карточки, нативного
 * чекбокса/радио в разметке нет, поле было бы мёртвой настройкой.
 */
export const OPTION_ACCENT_BLOCK_TYPES: ReadonlySet<string> = new Set([
  'single_choice',
  'multiple_choice',
  'multi_step_question',
  'checkbox',
  'terms_checkbox',
  // WEB-2158: две нативные отметки блока явного согласия.
  'sensitive_consent',
  'toggle',
  'plan_selector',
]);

/** Палитра воронки как дефолт отметки — вместо системно-синего браузера. */
export const DEFAULT_OPTION_ACCENT = 'var(--color-primary)';

/**
 * Значение `accent-color` для нативного чекбокса/радио блока.
 * Одна точка правды на оба рендерера (PublicBlockRenderer и
 * PublicBlockRendererExtended) — семь мест инпутов, одна логика.
 */
export function resolveOptionAccent(optionAccentColor?: string): string {
  return optionAccentColor || DEFAULT_OPTION_ACCENT;
}
